module.exports = __webpack_public_path__ + "static/media/github.41a24f73.svg";